import { TextExpanderEvents } from '@otto-ec/global-pattern';

export type InitialisedEvent = TextExpanderEvents['assets.textExpander.initialised'][0];

export type ToggledEvent = TextExpanderEvents['assets.textExpander.toggled'][0];

export class TextExpanderService {
    public sendInitEvent(selector: string): void {
        o_global.events<TextExpanderEvents>().emit('assets.textExpander.init', selector);
    }

    public registerCallbackOnInitialisation(selector: string, callback: (event: InitialisedEvent) => void): void {
        o_global.events<TextExpanderEvents>().on('assets.textExpander.initialised', (event: InitialisedEvent) => {
            if (event.target === document.querySelector(selector)) {
                callback(event);
            }
        });
    }

    public registerOnExpanderToggled(selector: string, onExpanderToggled: (event: ToggledEvent) => void): void {
        o_global.events<TextExpanderEvents>().on('assets.textExpander.toggled', (event: ToggledEvent) => {
            if (event.target === document.querySelector(selector)) {
                onExpanderToggled(event);
            }
        });
    }
}
